/**
 * Handler: homepage view event
 */

import type { WindowAnalyzify } from '../../types/window-analyzify';

export function handleHomepage(
  analyzify: WindowAnalyzify
): void {
  // Facebook - ViewHome event
  if (typeof analyzify.fbViewHome === 'function') {
    analyzify.fbViewHome();
  }

  // Bing - Homepage event
  if (typeof analyzify.bingHomepage === 'function') {
    analyzify.bingHomepage();
  }

  analyzify.log('Homepage view tracked', 'dispatcher');
}
